import { tagToSlug } from './tag';

export const HOME = '/';
export const BLOG = '/blog/';
export const GALLERY = '/gallery/';
export const LORE = '/lore/';
export const RULES = '/rules/';
export const ABOUT = '/about/';
export const LINKS = '/links/';
export const LEGAL = '/legal/';
export const TOOLS = '/tools/';
export const PAINT_PLAN = '/tools/paint-plan/';
export const TAGS = '/tags/';
export const BLOG_SHOW = (slug) => BLOG + slug;
export const GALLERY_SHOW = (slug) => GALLERY + slug;
export const RULES_SHOW = (slug) => RULES + slug;
export const PAINT_PLAN_SHOW = (year) => `${PAINT_PLAN}?year=${year}`;
export const TAG_SHOW = (tag) => `${TAGS}${tagToSlug(tag)}/`;
